import axios from "_u/axios"

// 商品活动管理列表
export const merchSellList = body => {
    return axios.post("api/merch/sell/list", body)
}

// 商品活动管理新增
export const merchSellAdd = body => {
    return axios.post("api/merch/sell/add", body)
}

// 商品活动管理上架/下架
export const merchSellEnable = id => {
    return axios.post("api/merch/sell/enable", { id })
}

// 商品活动管理更新
export const merchSellUpdate = body => {
    return axios.post("api/merch/sell/update", body)
}

// 商品活动管理查看
export const merchSellView = id => {
    return axios.post("api/merch/sell/view", { id })
}

// 商品活动管理删除
export const merchSellDel = id => {
    return axios.post("api/merch/sell/delete", { id })
}

// 商品管理列表
export const chooseList = body => {
    return axios.post("api/merch/info/chooseList",body)
}

// 售卖商品管理列表
export const chooseSellList = body => {
    return axios.post("api/merch/sell/chooseList",body)
}